<template>
    <vue-scroll>
        <div class="shopping-cart-container">
            <div class="shopping-cart-grid">
                <!-- Summary Section -->
                <div class="shopping-cart-summary">
                    <h2>Shopping Cart Summary</h2>
                    <div class="cart-summary">
                        <cart
                            ref="cart"
                            :show-products="true"
                            :with-header="false"
                            :show-product-delete-buttons="true"
                        />
                    </div>
                </div>

                <!-- Details Section -->
                <template v-if="$store.state.current_community.suspended">
                    <el-alert
                        title="Please contact Becky in the Business Office at becky@corwindesign.com to discuss an overdue invoice. Thank you - we appreciate your business!"
                        type="error"
                        :closable="false"
                        center
                    >
                    </el-alert>
                </template>
                <div class="shopping-cart-details">
                    <div>
                        <span
                            ><h2 class="cart-details__title">
                                Shopping Cart Details
                            </h2></span
                        >
                        <span style="align-items: right">
                            <template
                                v-if="
                                    !hasMissingCalendar &&
                                    !hasMissingNewsletter &&
                                    !$store.state.current_community.suspended
                                "
                            >
                                <el-button
                                    class="mb-10"
                                    type="primary"
                                    icon="mdi mdi-cash"
                                    :loading="cartForm.busy"
                                    @click="proceedCheckOut"
                                    >Proceed Checkout
                                </el-button>
                            </template>
                        </span>
                    </div>
                    <div
                        class="cart-details__content"
                        v-loading="cartForm.busy"
                        element-loading-text="Saving changes..."
                    >
                        <el-card
                            v-for="(order, i) in computedOrders"
                            :key="i"
                            class="order-card"
                        >
                            <!-- Order Header -->
                            <div slot="header" class="order-card__header">
                                <span class="order-card__title">
                                    <i
                                        :class="
                                            order.calendar_id
                                                ? 'mdi mdi-calendar'
                                                : 'mdi mdi-newspaper'
                                        "
                                    ></i>
                                    {{
                                        order.calendar_id
                                            ? order.community_location.name +
                                              " Calendar"
                                            : "Newsletter"
                                    }}
                                </span>
                                <el-button
                                    type="secondary"
                                    round
                                    icon="mdi mdi-plus"
                                    @click="
                                        order.calendar_id
                                            ? goToAddCalendarProducts(
                                                  order.calendar_id,
                                                  order.calendar.is_weekly
                                              )
                                            : goToAddNewsletterProducts(
                                                  order.newsletter_id
                                              )
                                    "
                                    size="small"
                                    style="margin-left: 10px"
                                >
                                    Add Products
                                </el-button>

                                <el-button
                                    type="danger"
                                    size="small"
                                    icon="mdi mdi-delete"
                                    style="margin-left: auto"
                                    @click="
                                        order.newsletter_id
                                            ? deleteNewsletter(order)
                                            : onDelete({ order })
                                    "
                                >
                                </el-button>
                            </div>

                            <el-collapse v-model="activeCollapse" accordion>
                                <el-collapse-item :name="i">
                                    <template slot="title">
                                        <span class="order-card__summary">
                                            {{ getOrderSummary(order) }}
                                        </span>
                                    </template>

                                    <!-- Newsletter Content -->
                                    <template v-if="order.newsletter_id">
                                        <div class="order-section">
                                            <el-divider
                                                >Digital Files</el-divider
                                            >
                                            <div class="product-grid">
                                                <div
                                                    class="product-card"
                                                    v-for="file in newsletterDigitalFiles"
                                                    :key="file.id"
                                                >
                                                    <div
                                                        v-if="file.image"
                                                        class="product-card__preview"
                                                    >
                                                        <img
                                                            :src="
                                                                file.image
                                                                    ?.url ||
                                                                '/images/placeholder.png'
                                                            "
                                                            :class="
                                                                previewSizeClass
                                                            "
                                                        />
                                                    </div>
                                                    <div
                                                        class="product-card__content"
                                                    >
                                                        <div
                                                            class="product-card__title"
                                                        >
                                                            <h5>
                                                                {{ file.name }}
                                                            </h5>
                                                        </div>
                                                        <div
                                                            class="product-card__description"
                                                        >
                                                            {{
                                                                file.description
                                                            }}
                                                        </div>
                                                        <div
                                                            class="product-card__details"
                                                        >
                                                            <div
                                                                class="product-card__controls"
                                                            >
                                                                <el-checkbox
                                                                    :label="
                                                                        file.id
                                                                    "
                                                                    :disabled="
                                                                        file.disabled
                                                                    "
                                                                    v-model="
                                                                        newsletterForm.digital_files
                                                                    "
                                                                    @change="
                                                                        (e) =>
                                                                            onChangeNewsletterDigitalFile(
                                                                                {
                                                                                    value: e,
                                                                                    file,
                                                                                    order_item:
                                                                                        order
                                                                                }
                                                                            )
                                                                    "
                                                                >
                                                                    Select File
                                                                </el-checkbox>
                                                            </div>
                                                            <div
                                                                class="product-card__price"
                                                            >
                                                                <label
                                                                    >Price</label
                                                                >
                                                                <span>{{
                                                                    file.price
                                                                        | currency
                                                                }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="order-section">
                                            <el-divider
                                                >Printed Newsletter</el-divider
                                            >
                                            <div class="product-grid">
                                                <div class="product-card">
                                                    <div
                                                        class="product-card__preview"
                                                    >
                                                        <img
                                                            src="/images/newsletter-print.png"
                                                            :class="
                                                                previewSizeClass
                                                            "
                                                        />
                                                    </div>
                                                    <div
                                                        v-if="order.quantity"
                                                        class="product-card__delete"
                                                    >
                                                        <el-button
                                                            type="danger"
                                                            icon="mdi mdi-delete"
                                                            size="mini"
                                                            @click="
                                                                deleteNewsletter(
                                                                    order
                                                                )
                                                            "
                                                        ></el-button>
                                                    </div>
                                                    <div
                                                        class="product-card__content"
                                                    >
                                                        <div
                                                            class="product-card__title"
                                                        >
                                                            <h5>
                                                                Printed
                                                                Newsletter
                                                                Quantity
                                                            </h5>
                                                        </div>
                                                        <div
                                                            class="product-card__details"
                                                        >
                                                            <div
                                                                class="product-card__quantity"
                                                            >
                                                                <label
                                                                    >Select
                                                                    Quantity</label
                                                                >
                                                                <el-select
                                                                    v-model.number="
                                                                        order.quantity
                                                                    "
                                                                    @change="
                                                                        onChangeNewsletterQuantity
                                                                    "
                                                                    style="
                                                                        width: 100%;
                                                                    "
                                                                >
                                                                    <el-option
                                                                        v-for="item in newsletterQuantityOptions"
                                                                        :key="
                                                                            item
                                                                        "
                                                                        :label="
                                                                            item
                                                                        "
                                                                        :value="
                                                                            item
                                                                        "
                                                                    />
                                                                </el-select>
                                                            </div>
                                                            <div
                                                                class="product-card__price"
                                                            >
                                                                <label
                                                                    >Price</label
                                                                >
                                                                <span>{{
                                                                    order.amount
                                                                        | currency
                                                                }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            v-if="
                                                order.birthday_posters &&
                                                order.birthday_posters.length
                                            "
                                            class="order-section"
                                        >
                                            <el-divider
                                                >Birthday Posters</el-divider
                                            >
                                            <birthday-posters
                                                :posters="
                                                    order.birthday_posters
                                                "
                                                :year="
                                                    order.year ||
                                                    new Date().getFullYear()
                                                "
                                                :month="
                                                    order.month ||
                                                    new Date().getMonth() + 1
                                                "
                                                @save="
                                                    saveBirthdayPosters(order)
                                                "
                                            />
                                        </div>
                                    </template>

                                    <!-- Calendar Content -->
                                    <template v-else>
                                        <template
                                            v-if="order[SizeTypes.FLAT].length"
                                        >
                                            <el-divider
                                                >Printed Copies</el-divider
                                            >
                                            <div class="product-grid">
                                                <product-card
                                                    v-for="(
                                                        size, flat_size_id
                                                    ) in order[SizeTypes.FLAT]"
                                                    :key="flat_size_id"
                                                    show-price
                                                    @change-quantity="
                                                        (e) =>
                                                            onChangeQuantity({
                                                                quantity: e,
                                                                order,
                                                                order_item_size:
                                                                    size
                                                            })
                                                    "
                                                    @delete="
                                                        onDelete({
                                                            order,
                                                            order_item_size:
                                                                size
                                                        })
                                                    "
                                                    :order-item-size="size"
                                                    :calendar-format="
                                                        order.calendar
                                                            .calendar_format
                                                    "
                                                    :size="size.size"
                                                    :color-type="
                                                        size.color_type
                                                    "
                                                    :previewSize="
                                                        previewSizeClass
                                                    "
                                                />
                                            </div>
                                        </template>
                                        <template
                                            v-if="
                                                order[SizeTypes.POSTER].length
                                            "
                                        >
                                            <div class="order-section">
                                                <el-divider
                                                    >Printed Posters</el-divider
                                                >
                                                <div class="product-grid">
                                                    <div
                                                        class="flex-col-33 flex-col-xl-25"
                                                        v-for="(
                                                            size, poster_size_id
                                                        ) in order[
                                                            SizeTypes.POSTER
                                                        ]"
                                                        :key="poster_size_id"
                                                    >
                                                        <product-card
                                                            show-price
                                                            @change-quantity="
                                                                (e) =>
                                                                    onChangeQuantity(
                                                                        {
                                                                            quantity:
                                                                                e,
                                                                            order: order,
                                                                            order_item_size:
                                                                                size
                                                                        }
                                                                    )
                                                            "
                                                            @delete="
                                                                onDelete({
                                                                    order,
                                                                    order_item_size:
                                                                        size
                                                                })
                                                            "
                                                            :order-item-size="
                                                                size
                                                            "
                                                            :calendar-format="
                                                                order.calendar
                                                                    .calendar_format
                                                            "
                                                            :size="size.size"
                                                            :color-type="
                                                                size.color_type
                                                            "
                                                            :previewSize="
                                                                previewSizeClass
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template
                                            v-if="order.digital_files.length"
                                        >
                                            <div class="order-section">
                                                <el-divider
                                                    >Digital Files</el-divider
                                                >
                                                <div class="product-grid">
                                                    <div
                                                        class="flex-col-33 flex-col-xl-25"
                                                        v-for="file in order.digital_files"
                                                        :key="file.id"
                                                    >
                                                        <product-card
                                                            :show-price="true"
                                                            @delete="
                                                                onDeleteDigitalFile(
                                                                    {
                                                                        order,
                                                                        order_item_digital_file:
                                                                            file
                                                                    }
                                                                )
                                                            "
                                                            :order-item-digital-file="
                                                                file
                                                            "
                                                            :digital-file="
                                                                file.digital_file
                                                            "
                                                            :requires-quantity="
                                                                false
                                                            "
                                                            :previewSize="
                                                                previewSizeClass
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template
                                            v-if="order.printed_extras.length"
                                        >
                                            <div class="order-section">
                                                <el-divider
                                                    >Printed Extras</el-divider
                                                >
                                                <div class="product-grid">
                                                    <div
                                                        :key="extra.id"
                                                        class="flex-col-33 flex-col-xl-25"
                                                        v-for="extra in order.printed_extras"
                                                    >
                                                        <product-card
                                                            v-if="
                                                                extra
                                                                    .printed_extra
                                                                    .is_active
                                                            "
                                                            show-price
                                                            :order-item-printed-extra="
                                                                extra
                                                            "
                                                            :printed-extra="
                                                                extra.printed_extra
                                                            "
                                                            :requires-quantity="
                                                                true
                                                            "
                                                            @change-quantity="
                                                                (e) =>
                                                                    onChangeQuantity(
                                                                        {
                                                                            quantity:
                                                                                e,
                                                                            order: order,
                                                                            order_item_printed_extra:
                                                                                extra
                                                                        }
                                                                    )
                                                            "
                                                            @delete="
                                                                onDeletePrintedExtra(
                                                                    {
                                                                        order,
                                                                        order_item_printed_extra:
                                                                            extra
                                                                    }
                                                                )
                                                            "
                                                            :preview-size="
                                                                previewSizeClass
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template
                                            v-if="order.birthday_posters.length"
                                        >
                                            <div class="order-section">
                                                <el-divider
                                                    >Birthday
                                                    Posters</el-divider
                                                >
                                                <birthday-posters
                                                    :posters="
                                                        order.birthday_posters
                                                    "
                                                    :saving="
                                                        birthdayPostersForm.busy
                                                    "
                                                    :month="
                                                        order.calendar.month
                                                    "
                                                    :year="order.calendar.year"
                                                    @save="
                                                        saveBirthdayPosters(
                                                            order
                                                        )
                                                    "
                                                />
                                            </div>
                                        </template>
                                    </template>
                                </el-collapse-item>
                            </el-collapse>
                        </el-card>
                        <template
                            v-if="$store.state.current_community.suspended"
                        >
                            <el-alert
                                title="Please contact Becky in the Business Office at becky@corwindesign.com to discuss an overdue invoice. Thank you - we appreciate your business!"
                                type="error"
                                :closable="false"
                                center
                            >
                            </el-alert>
                        </template>
                        <div class="mt-10" v-else>
                            <template
                                v-if="
                                    !hasMissingCalendar && !hasMissingNewsletter
                                "
                            >
                                <el-button
                                    class="mb-10"
                                    type="primary"
                                    icon="mdi mdi-cash"
                                    :loading="cartForm.busy"
                                    @click="proceedCheckOut"
                                    >Proceed Checkout
                                </el-button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import * as ColorTypes from "@/constants/color-types";
import DigitalFiles from "@/constants/digital-files";
import * as SizeTypes from "@/constants/size-types";
import cart_updated_listener from "@/mixins/cart-updated-listener";
import cart_mixin from "@/mixins/cart_mixin";
import * as Actions from "@/store/constants/actions";
import * as Getters from "@/store/constants/getters";
import * as Mutations from "@/store/constants/mutations";
import store from "@/store/index.js";
import BirthdayPosters from "@/views/pages/calendar/single/place-order/BirthdayPosters";
import { mapGetters, mapState } from "vuex";
import Cart from "../calendar/single/place-order/Cart";
import ProductCard from "../calendar/single/place-order/ProductCard";
import { getRoutesUtil } from "@/utils/routes.default";
export default {
    mixins: [cart_mixin, cart_updated_listener],
    components: {
        ProductCard,
        Cart,
        BirthdayPosters
    },
    props: {
        editable: {
            type: Boolean,
            default: true
        }
    },
    beforeRouteEnter(to, from, next) {
        store
            .dispatch(Actions.FETCH_CART)
            .then((response) => {
                next((vm) => {
                    vm.orders = _.cloneDeep(response.data.orders);
                });
            })
            .catch(() => {
                next(false);
            });
    },
    data() {
        return {
            ColorTypes,
            SizeTypes,
            cartForm: new Form({
                orders: []
            }),
            orders: [],
            activeTab: 0,
            birthdayPostersForm: new Form({
                calendar_id: null,
                birthday_posters: []
            }),
            newsletterForm: new Form({
                digital_files: []
            }),
            previewSizeClass: "image-width-50",
            activeCollapse: [], // [0] First item expanded by default
            routes_util: null
        };
    },
    created() {
        this.initForm();
        // Initialize routes_util with the current router instance
        this.routes_util = getRoutesUtil(this.$router);
    },
    computed: {
        ...mapState(["cart"]),
        ...mapState({
            sizes: (state) => state.sizes.data,
            digital_files: (state) => state.digital_files.data,
            printed_extras: (state) => state.printed_extras.data
        }),
        ...mapGetters([
            Getters.NEWSLETTER_REQUIRES_QUANTITY,
            Getters.NEWSLETTER_QUANTITY_OPTIONS
        ]),
        newsletterDigitalFiles() {
            return _.map(
                this.$store.getters[Getters.NEWSLETTER_DIGITAL_FILES],
                (file) => {
                    return {
                        ...file,
                        disabled:
                            this.requiresNewsletterPdfProof &&
                            file.id == DigitalFiles.newsletterPdfOnly
                    };
                }
            ).filter((file) => {
                return !file.disabled;
            });
        },
        computedOrders() {
            //console.log(this.orders);
            let resposne = this.orders.map((order) => {
                if (order.calendar_id) {
                    order.sizes.forEach((size) => {
                        size.size = _.find(this.sizes, { id: size.id });
                    });
                    order.digital_files.forEach((file) => {
                        file.digital_file = _.find(this.digital_files, {
                            id: file.id
                        });
                    });
                    order.printed_extras.forEach((extra) => {
                        extra.printed_extra = _.find(this.printed_extras, {
                            id: extra.id
                        });
                    });
                    _.forEach(SizeTypes, (type) => {
                        order[type] = _.filter(order.sizes, { type: type });
                    });
                    return order;
                } else {
                    return order;
                }
            });
            //console.log("computedOrders", resposne);
            return resposne;
        }
    },
    methods: {
        onChangeCollapse() {
            setTimeout(() => {
                this.updateScroller();
            }, 400);
        },
        initForm() {
            this.orders = _.cloneDeep(this.cart.orders);
            //console.log("this.orders", this.orders);
            this.initNewsletterForm();
        },
        initNewsletterForm() {
            let newsletter_order_item = this.orders.find(
                (item) => !!item.newsletter_id
            );
            if (newsletter_order_item) {
                this.newsletterForm.digital_files = _.values(
                    newsletter_order_item.digital_files.map((item) => item.id)
                );
            }
        },
        onCartUpdated() {
            this.initForm();
        },
        onChangeQuantity({
            quantity,
            order,
            order_item_size = null,
            order_item_printed_extra = null
        }) {
            if (order_item_size) {
                order_item_size.quantity = quantity;
            } else if (order_item_printed_extra) {
                order_item_printed_extra.quantity = quantity;
            }
            this.saveCart();
        },
        onChangeNewsletterQuantity() {
            //check if quantity of newsletters is greater than quantity of calendars
            //console.log("onChangeNewsletterQuantity", this.orders);
            if (!this.newsletterRequiresQuantity) {
                this.saveCart();
            }
        },
        onChangeNewsletterDigitalFile({ value, file, order_item }) {
            if (this.requiresNewsletterPdfProof) {
                if (!value && file.id === DigitalFiles.newsletterPdfProof) {
                    // Show info message when trying to uncheck required PDF proof
                    this.$message({
                        message: "PDF proof is required for this newsletter",
                        type: "warning",
                        showClose: true,
                        duration: 5000
                    });
                }
                this.newsletterForm.digital_files = [
                    DigitalFiles.newsletterPdfProof
                ];
                return;
            }
            if (value) {
                this.newsletterForm.digital_files = [file.id];
            }
            order_item.digital_files = _.values(
                this.newsletterForm.digital_files.map((item) => {
                    return { id: item };
                })
            );
            this.saveCart();
        },
        deleteNewsletter(order) {
            this.$confirm(
                "Confirm remove newsletter from shopping cart?",
                "Confirmation",
                {
                    confirmButtonText: "Remove",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "el-button--danger",
                    type: "warning"
                }
            )
                .then(() => {
                    Utils.arrayDelete(this.orders, order);
                    this.saveCart().then(() => {
                        this.$notify.success({
                            message: "Newsletter has been removed."
                        });
                    });
                })
                .catch(() => {});
        },
        onDelete({ order, order_item_size }) {
            this.$confirm(
                order_item_size
                    ? "Confirm remove item from shopping cart?"
                    : "Confirm remove entire calendar from shopping cart?",
                "Confirmation",
                {
                    confirmButtonText: "Remove",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "el-button--danger",
                    type: "warning"
                }
            )
                .then(() => {
                    if (order_item_size) {
                        // Delete just the specific size item
                        order.sizes = _.filter(order.sizes, (item) => {
                            return item != order_item_size;
                        });
                    } else {
                        // Delete the entire order
                        Utils.arrayDelete(this.orders, order);
                    }

                    this.saveCart().then(() => {
                        this.$notify.success({
                            message: order_item_size
                                ? "Item has been removed."
                                : "Calendar has been removed."
                        });
                    });
                })
                .catch(() => {});
        },
        onDeleteDigitalFile({ order, order_item_digital_file }) {
            this.$confirm(
                "Confirm remove item from shopping cart?",
                "Confirmation",
                {
                    confirmButtonText: "Remove",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "el-button--danger",
                    type: "warning"
                }
            )
                .then(() => {
                    order.digital_files = _.filter(
                        order.digital_files,
                        (item) => {
                            return item != order_item_digital_file;
                        }
                    );
                    this.saveCart().then(() => {
                        this.$notify.success({
                            message: "Item has been removed."
                        });
                    });
                })
                .catch(() => {});
        },
        onDeletePrintedExtra({ order, order_item_printed_extra }) {
            this.$confirm(
                "Confirm remove item from shopping cart?",
                "Confirmation",
                {
                    confirmButtonText: "Remove",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "el-button--danger",
                    type: "warning"
                }
            )
                .then(() => {
                    order.printed_extras = _.filter(
                        order.printed_extras,
                        (item) => {
                            return item != order_item_printed_extra;
                        }
                    );
                    this.saveCart().then(() => {
                        this.$notify.success({
                            message: "Item has been removed."
                        });
                    });
                })
                .catch(() => {});
        },
        saveBirthdayPosters(order) {
            // Create a form with the appropriate ID field based on order type
            if (order.calendar_id) {
                _.extend(
                    this.birthdayPostersForm,
                    _.pick(order, ["calendar_id", "birthday_posters"])
                );
            } else if (order.newsletter_id) {
                _.extend(this.birthdayPostersForm, {
                    newsletter_id: order.newsletter_id,
                    birthday_posters: order.birthday_posters
                });
            }

            // Use the same endpoint for both
            App.post(
                `/web-api/cart/birthday-posters`,
                this.birthdayPostersForm
            ).then((response) => {
                this.$store.commit(Mutations.SET_CART, response.data);
                this.$notify.success({
                    message: "Birthday posters have been saved."
                });
            });
        },
        saveCart() {
            this.cartForm.orders = this.orders;
            return window.App.put(`/web-api/cart`, this.cartForm).then(
                (response) => {
                    this.$store.commit(Mutations.SET_CART, response.data);
                    return response;
                }
            );
        },
        proceedCheckOut() {
            if (this.cartEditable) {
                this.saveCart().then(() => {
                    this.routes_util.safeNavigate({
                        name: "Checkout"
                    });
                });
            } else {
                this.routes_util.safeNavigate({
                    name: "Checkout"
                });
            }
        },
        getOrderSummary(order) {
            //console.log("getOrderSummary", order);
            if (order.newsletter_id) {
                const totalItems = [...(order["digital_files"] || [])];
                return `${totalItems.length + 1} Products`;
            }
            const totalItems = [
                ...(order[this.SizeTypes.FLAT] || []),
                ...(order[this.SizeTypes.POSTER] || []),
                ...(order["digital_files"] || []),
                ...(order["printed_extras"] || [])
            ];
            return `${totalItems.length} Products`;
        },
        goToAddCalendarProducts(calendar_id, is_weekly) {
            // Navigate to calendar edit page with step 5 (place order)
            let stepNumber = is_weekly ? 3 : 5;
            this.$router.push({
                name: "EditCalendar",
                params: {
                    id: calendar_id // Make sure you have access to calendar_id
                },
                query: { step: stepNumber }
            });
        },
        goToAddNewsletterProducts(newsletter_id) {
            this.$router.push({
                name: "EditNewsletter",
                params: {
                    id: newsletter_id
                },
                query: { step: 6 }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/product-card.scss";

.shopping-cart-container {
    padding: 16px;
    width: 100%;
    //max-width: 1200px;
    margin: 0 auto;
}

.shopping-cart-grid {
    display: grid;
    gap: 24px;

    @media (min-width: 768px) {
        grid-template-columns: 1fr 2fr;
        align-items: start;
    }
}

.shopping-cart-summary {
    @media (min-width: 768px) {
        position: sticky;
        top: 24px;
    }
}

.cart-summary {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 16px;
    margin-top: 16px;
}

.shopping-cart-details {
    .order-card {
        margin-bottom: 16px;

        &__header {
            display: flex;
            //justify-content: space-between;
            align-items: center;
            padding: 16px;
            background: #f8f9fa;
            border-radius: 8px 8px 0 0;
            border-bottom: 1px solid #ebeef5;
            font-size: 20px;
            font-weight: 500;
            color: #303133;

            .order-card__title {
                display: flex;
                align-items: center;

                i {
                    margin-right: 8px;
                }
            }

            .order-card__summary {
                font-size: 14px;
                font-weight: 500;
                color: #606266;
            }
        }

        @media (max-width: 767px) {
            margin: 0 -16px 16px;
            border-radius: 0;
        }
    }
}

.cart-details {
    &__title {
        margin-bottom: 24px;

        @media (max-width: 767px) {
            margin-bottom: 16px;
        }
    }

    &__content {
        @media (max-width: 767px) {
            margin: 0 -16px;
        }
    }
}

h2 {
    font-size: 24px;
    font-weight: 600;
    color: #303133;

    @media (max-width: 767px) {
        font-size: 20px;
    }
}

.product-grid {
    display: grid;
    gap: 20px;
    margin: 16px 0;

    @media (max-width: 767px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
    }
}

.el-checkbox {
    display: flex !important;
    align-items: flex-start !important;
    margin-bottom: 12px;

    .el-checkbox__input {
        margin-top: 2px; // Adjust this value to fine-tune alignment
    }

    .el-checkbox__label {
        display: inline-block;
        line-height: 1.2;

        span {
            display: block;
            margin-bottom: 4px;
        }

        .description {
            font-size: 12px;
            color: #909399;
            white-space: normal;
        }
    }
}

.order-section {
    .birthday-posters-card {
        margin-left: 0 !important;
        margin-right: auto !important;
    }
}

/* Improved collapse item styling to match PlaceOrder.vue */
:deep(.el-collapse-item) {
    margin-bottom: 16px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    
    .el-collapse-item__header {
        background-color: #f5f7fa;
        font-weight: 600;
        font-size: 18px;
        color: #0c7b93; /* Using a specific blue-green color as fallback */
        height: 55px;
        line-height: 55px;
        padding: 0 20px;
        border-left: 4px solid #0c7b93;
        display: flex;
        align-items: center;
        
        &:hover {
            background-color: #eef1f6;
        }
        
        &.is-active {
            background-color: #0c7b93;
            color: white;
            border-bottom-color: transparent;
        }
        
        .el-collapse-item__arrow {
            margin-right: 15px;
            margin-left: auto;
            font-size: 16px;
            color: inherit;
        }
    }
    
    .el-collapse-item__content {
        padding: 20px;
        background-color: white;
    }
}

/* Additional styling for order card collapse items */
.order-card :deep(.el-collapse) {
    border: none;
    
    .el-collapse-item {
        border: none;
        
        .el-collapse-item__header {
            border-top: none;
            border-bottom: 1px solid #dcdfe6;
        }
    }
}
</style>
